import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import blankImagePng from 'src/assets/blank-image.png'

export class Image extends Component {
  static propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
    onLoad: PropTypes.func,
    src: PropTypes.string,
    cover: PropTypes.bool,
    fadeIn: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    alt: 'MeetMarket Image',
    onLoad: () => {},
    src: blankImagePng,
    cover: true,
    fadeIn: false,
  }

  state = {
    loaded: false,
  }

  componentDidMount = () => {
    this.mounted = true
    this.img.complete && setTimeout(this.onLoad, 100)
  }

  componentWillUnmount = () => {
    this.mounted = false
  }

  onLoad = () => {
    if (!this.mounted) return
    this.setState({ loaded: true })
    this.props.onLoad(this)
  }

  get rest() {
    let props = { ...this.props }
    delete props.className
    delete props.alt
    delete props.onLoad
    delete props.src
    delete props.staticContext
    delete props.cover
    delete props.fadeIn
    return props
  }

  get className() {
    const { className, cover, fadeIn } = this.props
    const { loaded } = this.state
    return c('im-image', loaded && 'loaded', fadeIn && 'fade-in', cover && 'size-cover', className)
  }

  render() {
    const { alt, src } = this.props
    const { className, onLoad, rest } = this
    return (
      <div className={className} {...rest}>
        <img ref={img => (this.img = img)} src={src} alt={alt} onLoad={onLoad} />
        <div
          className="css-image"
          ref={node => (this.node = node)}
          style={{ backgroundImage: `url(${src})` }}
        />
      </div>
    )
  }
}

export default Image
